module.exports = __webpack_public_path__ + "img/EA783E_6D4830_905837_FCDC6C-256px.363f6445.png";